// extracted by css-extract-rspack-plugin
export default {"value":"QBW1R","hoverable":"G08yY"};